import { Link, useOutletContext, useParams } from "react-router-dom";
import CountryCardShimmerEffect from "./CountryCardShimmerEffect";
import { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../Conterxts/ThemeContext";
import "./CountryDetail.css";
import useTheme from "../hooks/UseTheme";

export default function CountryDetail() {
  // const [IsDark] = useContext(ThemeContext)
  const [IsDark] = useTheme();

  // const [IsDark] = useOutletContext()

  // const countryName = new URLSearchParams(location.search).get("name");
  // console.log(countryName);
  const param = useParams();
  const countryName = param.country;

  const [countryData, setCountryData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    fetch(`https://restcountries.com/v3.1/name/${countryName}?fullText=true`)
      .then((res) => res.json())
      .then(([data]) => {
        setCountryData({
          name: data.name.common,
          nativeName: data.name.common || {},
          region: data.region,
          population: data.population,
          subregion: data.subregion,
          capital: data.capital,
          tld: data.tld,
          flags: data.flags.svg,
          languages: Object.values(data.languages || {}).join(", "),
          currencies: Object.values(data.currencies || {})
            .map((currency) => currency.name)
            .join(", "),
          borders: [],
        });

        data.borders.map((border) => {
          fetch(`https://restcountries.com/v3.1/alpha/${border}`)
            .then((res) => res.json())
            .then(([borderCountry]) => {
              setCountryData((prevState) => ({
                ...prevState,
                borders: [...prevState.borders, borderCountry.name.common],
              }));
            });
        });
      })
      .catch((err) => {
        setNotFound(true);
      });
  }, [countryName]);

  if (notFound) {
    return <h1>This page is not found</h1>;
  }

  if (!countryData) {
    return <CountryCardShimmerEffect />;
  }

  return countryData === null ? (
    "Loading..."
  ) : (
    <main className={`${IsDark ? "dark" : ""}`}>
      <div className="country-details-container">
        <span className="back-button" onClick={() => history.back()}>
          <i className="fa-solid fa-arrow-left"></i>&nbsp; Back
        </span>
        <div className="country-details">
          <img src={countryData.flags} alt={"${countryData.name} flag"} />
          <div className="details-text-container">
            <h1>{countryData.name}</h1>
            <div className="details-text">
              <p>
                <b>Native Name: {countryData.nativeName || countryData.name}</b>
                <span className="native-name"></span>
              </p>
              <p>
                <b>
                  Population: {countryData.population.toLocaleString("en-IN")}
                </b>
                <span className="population"></span>
              </p>
              <p>
                <b>Region: {countryData.region}</b>
                <span className="region"></span>
              </p>
              <p>
                <b>Sub Region: {countryData.subregion}</b>
                <span className="sub-region"></span>
              </p>
              <p>
                <b>Capital: {countryData.capital?.join(", ")}</b>
                <span className="capital"></span>
              </p>
              <p>
                <b>Top Level Domain: {countryData.tld}</b>
                <span className="top-level-domain"></span>
              </p>
              <p>
                <b>Currencies: {countryData.currencies}</b>
                <span className="currencies"></span>
              </p>
              <p>
                <b>Languages: {countryData.languages}</b>
                <span className="languages"></span>
              </p>
            </div>
            {countryData.borders.length !== 0 && (
              <div className="border-countries">
                <b>Border Countries: </b>&nbsp;
                {countryData.borders.map((border) => (
                  <Link key={border} to={`/${border}`}>
                    {border}
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
